import type {NodeClassImpl} from "#template/runtime-graph/types"
import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"
import type {ISceneManager} from "#template/interfaces/scene-manager"
import type {MaterialGraph} from "@cm/material-nodes"
import type {Subscription} from "rxjs"
import {defer, map} from "rxjs"

const TD = TypeDescriptors

const findMaterialDescriptor = {
    sceneManager: TD.inlet(TD.Identity<ISceneManager>()),
    customerId: TD.inlet(TD.Nullable(TD.Number)),
    articleId: TD.inlet(TD.Nullable(TD.String)),
    flatten: TD.inlet(TD.Boolean),
    materialGraph: TD.outlet(TD.Nullable(TD.MaterialGraph)),
}

export class FindMaterial implements NodeClassImpl<typeof findMaterialDescriptor, typeof FindMaterial> {
    static descriptor = findMaterialDescriptor
    static uniqueName = "FindMaterial"
    sceneManager!: Inlet<ISceneManager>
    customerId!: Inlet<number | null>
    articleId!: Inlet<string | null>
    flatten!: Inlet<boolean>
    materialGraph!: Outlet<MaterialGraph | null>

    private pending: Subscription | null = null

    run() {
        this.cleanup()

        if (this.sceneManager === NotReady || this.articleId === NotReady || this.customerId === NotReady || this.flatten === NotReady) {
            this.materialGraph.emitIfChanged(NotReady)
            return
        }

        if (this.articleId === null) {
            this.materialGraph.emitIfChanged(null)
            return
        }

        const {sceneManager, articleId, customerId, flatten} = this

        this.pending = this.sceneManager.addTask({
            description: `findMaterial(${this.articleId}, ${this.customerId}, ${this.flatten})`,
            task: defer(() => sceneManager.findMaterial(articleId, customerId, flatten)).pipe(
                map((materialGraph) => {
                    this.materialGraph.emitIfChanged(materialGraph)
                }),
            ),
            critical: true,
        })
    }

    cleanup() {
        this.pending?.unsubscribe()
        this.pending = null
    }
}
